import { type DocumentNode, gql } from '@apollo/client';

const updateFieldMapsConfigMutation: DocumentNode = gql`
  mutation update_field_maps_config($name: String, $fieldMapConfigId: ID!) {
    updateFieldMapConfig(name: $name, fieldMapConfigId: $fieldMapConfigId) {
      fieldMapConfig {
        id
        name
      }
    }
  }
`;

export default updateFieldMapsConfigMutation;
